import styles from "./resetPasswordForm.module.css";
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
function ResetPasswordForm() {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError("Passwörter stimmen nicht überein.");
            return;
        }

        // Optional: enforce minimum length
        if (newPassword.length < 8) {
            setError("Das Passwort muss mindestens 8 Zeichen lang sein.");
            return;
        }
        setError(null);
        const res = await fetch('/api/auth/reset-password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, token, newPassword }),
        });
        const data = await res.json();
        setStatus(data.message || data.error);
    };

    return (
        <div className={styles.container}>
            <h1>Passwort zurücksetzen</h1>
            <p></p>
            <div className={styles.formContainer}>
                <form className={styles.form} onSubmit={handleSubmit}>
                    {status ?
                        (
                            <p className={styles.status}>{status}</p>
                        ) :
                        (
                            <>
                                <input
                                    type="password"
                                    placeholder="Neues Passwort"
                                    value={newPassword}
                                    onChange={e => setNewPassword(e.target.value)}
                                    required
                                />
                                <input
                                    type="password"
                                    placeholder="Neues Passwort wiederholen"
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                    required
                                />
                                {error && <p className={styles.error}>{error}</p>}
                                <button className={styles.button} type="submit">Passwort zurücksetzen</button>
                            </>
                        )
                    }
                </form>
                <button
                    type="button"
                    className={styles.loginButton}
                    onClick={() => navigate('/admin')}
                >
                    Zurück zum Login
                </button>
            </div>
        </div>
    );
}
export default ResetPasswordForm;